// @flow
// ----------------------------------------------------------------------
// <copyright file='Izenda.PasswordSetup.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
import React, { Component } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import AccountInfo from 'modules/Account/Izenda.AccountInfo';
import SecurityInfo from 'modules/Account/Izenda.SecurityInfo';
import actions from 'modules/Account/Izenda.PasswordSetupActions';

class PasswordSetup extends Component {
  componentWillMount() {
    this.props.updateToAccountInfoStep(this);
  }

  render() {
    const { store, store: { model: { isExpiration } } } = this.props;
    if (isExpiration) return null;

    return (
      <div className='izenda-Account-PasswordSetup u_inlineBlock'>
        <AccountInfo store={store} />
        <SecurityInfo store={store} />
      </div>
    );
  }
}

export default connect(actions)(PasswordSetup);


// WEBPACK FOOTER //
// ./ui/modules/Account/Izenda.PasswordSetup.js